export default __webpack_public_path__ + "static/media/oh-sure.175c91f7.gif";